import Image from "next/image";
import { useId } from "react"; // 1. Import useId

type PersonalityCardProps = {
  name: string;
  year: string;
  img: string;
};

export default function PersonalityCard(props: PersonalityCardProps) {
  const { name, year, img } = props;
  const gradientId = useId();

  return (
    <div className="personality-card relative overflow-hidden text-center">
      <svg
        className="pointer-events-none absolute inset-0 z-0 h-full w-full"
        fill="none"
        viewBox="0 0 533 674"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient
            id={gradientId}
            x1="7.94232e-06"
            y1="338"
            x2="339.693"
            y2="-137.963"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.501658" stopColor="#F0DFC1" />
            <stop offset="0.847671" stopColor="#C89452" />
            <stop offset="1" stopColor="#B07F44" />
          </linearGradient>
        </defs>
        <path
          d="M266.5 4C411.475 4 529 121.525 529 266.5V630.027C529 653.208 510.208 672 487.027 672H45.9727C22.7918 672 4 653.208 4 630.027V266.5C4 121.525 121.525 4 266.5 4Z"
          stroke={`url(#${gradientId})`}
          strokeWidth="8"
        />
      </svg>

      <Image
        className="z-[-1] scale-[0.7] object-contain"
        fill
        src={img}
        alt={name}
        sizes="(max-width: 768px) 50vw, (max-width: 1200px) 33vw, 25vw"
        priority={false}
      />

      <h3 className="text-base leading-[16px] text-[#F3E4CE] xs:text-xl xs:leading-[20px] 2xl:pb-6 2xl:text-[2rem] ltr:font-playfair">
        {name}
      </h3>
      <p className="text-sm text-[#ffcc68] sm:text-base lg:text-xl 2xl:text-2xl">{year}</p>
      <div className="absolute bottom-1 z-[-1] h-1/3 w-full bg-gradient-to-t from-[#70488e] via-[#70488e] to-transparent"></div>
    </div>
  );
}
